import Cookies from "universal-cookie";
import { BaseApi } from "./BaseUrl";
import axios from "axios";

export async function GetInputOutputHistory(year:any,month:any): Promise<Array<{}>> {
    try {
        var user= new Cookies().get('user');
        const requestOptions = {
          headers: { 'Authorization':user.Token}};
        const response = await axios.get(BaseApi+'HR/GetInputOutputHistory?year='+year+'&month='+month,requestOptions);
        return response.data;
    }
    catch (error) {
        console.error(error);
        return []; // اگر خطایی رخ دهد، یک آرایه خالی برگردانده می‌شود
    }
}